import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { createImmutableObjectClass } from 'immutable-less';
import produce from 'immer';
import { cleanObject } from 'marketplace-ui-common/utils/formatters';
import FieldMapping from './FieldMapping';
const DataSyncDefaults = {
  data: '',
  sync: 'INBOUND',
  target: '',
  description: '',
  fieldMappings: []
};
export default class DataSync extends createImmutableObjectClass(DataSyncDefaults, {
  fromJSON: _ref => {
    let rest = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
    const data = Object.assign({}, rest);
    return cleanObject(Object.assign({}, data, {
      fieldMappings: data.fieldMappings = rest.fieldMappings.map(mapping => new FieldMapping(mapping))
    }));
  },
  toJSON: _ref2 => {
    let rest = Object.assign({}, (_objectDestructuringEmpty(_ref2), _ref2));
    return Object.assign({}, rest);
  }
}) {
  getFieldMappingsByType(fieldType) {
    return this.fieldMappings.filter(mapping => mapping.fieldType === fieldType);
  }
  filterEmptyFieldMappings() {
    return this.set('fieldMappings', this.get('fieldMappings').filter(mapping => mapping.isValid()));
  }
  hasRequiredFields() {
    return Boolean(this.data && this.sync && this.target);
  }
  updateDataSync(updates) {
    return produce(this, dataSyncDraft => {
      Object.entries(updates).forEach(([key, value]) => {
        dataSyncDraft.set(key, value);
      });
    });
  }
}